/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 14:45:16
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2019-12-30 13:38:48
 * @Description: file content
 */
import qs from "qs";
import api from "@/api/act-logic-dengfan"
import myAxios from "./interceptors"
import Vue from 'vue/dist/vue.js'
let axios = new myAxios();
let _options = {};
const Mock = require('mockjs');
// Add a request interceptor
axios.axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // console.log("http interceptors by act-logic-dengfan");

  config.headers.fromOpenId = Vue.prototype.$fopenid;
  config.headers.appId = _options.appId;
  config.headers.infoId = _options.infoId;
  config.headers.channel = Vue.prototype.$channel;
  config.headers.openid = Vue.prototype.$openid;
  // console.log("config", config);
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
// Add a response interceptor
axios.axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  if (response.config.headers.res) {
    switch (response.config.headers.res) {
      case 'data':
        if (response.data) {
          response = response.data;
        }
        break;
      case 'data2':
        if (response.data && response.data.hasOwnProperty('data')) {
          response = response.data.data;
        } else {
          return Promise.reject(response);
        }
        break;
      default:
        break;
    }
  }
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});

export default {
  options: _options,
  qs: qs,
  post2(url, param, option) {
    if (process.env.VUE_APP_MOCK == 1) {
      if (typeof url == "object" && url.mock) {
        Mock.mock(`${api.protocol}//${api.domain}${url.api}`, 'post', url.mock);
      } else {
        console.warn(`已启动全局mock，但 ${url} 没有配置mock数据，请留意`);
      }
    }
    // let realUrl = "";
    // if (typeof url == "object") {
    //   realUrl = url.api;
    // } else {
    //   realUrl = url;
    // }
    return new Promise((resolve, reject) => {
      axios.axios({
          method: "post",
          url,
          data: qs.stringify(param),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        })
        .then(res => {
          if (option && option.mask) {
            // Indicator.close();
          }
          resolve(res);
        })
        .catch(function (error) {
          // Indicator.close();
          reject(error);
        });
    })
  }
}